import { render, staticRenderFns } from "./_Loading.vue?vue&type=template&id=36c66af2&"
import script from "./_Loading.vue?vue&type=script&lang=js&"
export * from "./_Loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports